/**
 * 使用 require.context 动态导入当前目录下的所有 .js 文件。
 * require.context 是 Webpack 提供的函数，用于创建自己的上下文模块。
 * 第一个参数 '.' 表示当前目录；
 * 第二个参数 false 表示不搜索子目录；
 * 第三个参数 /.*\.js$/ 是一个正则表达式，表示匹配所有以 .js 结尾的文件。
 */
const apis = require.context('.', false, /.*\.js$/);
/**
 * 初始化一个空对象 apiObj，用于存储从各个模块导入的 API。
 * 后续会将不同文件中的 API 以文件名作为键添加到这个对象中。
 */
let apiObj = {};
/**
 * 遍历 require.context 返回的所有模块的键（即文件名）。
 * 对每个文件名进行处理，将对应的模块默认导出添加到 apiObj 中。
 */
apis.keys().forEach(fileName => {
	// 排除当前文件 index.js，避免将自身导入到 apiObj 中
	if (fileName !== './index.js') {
		// 提取文件名（去掉 './' 前缀和文件扩展名）作为 apiObj 的键名。
		const name = fileName.substring(2, fileName.lastIndexOf('.'))
		// 将对应模块的默认导出赋值给 apiObj 中以该文件名命名的属性
		apiObj[name] = apis(fileName).default;
	}
});
/**
 * 导出包含所有 API 的对象 apiObj。
 * 其他模块可以通过导入该对象来使用这里收集的所有 API。
 */
export default apiObj;
